import { useCallback, useEffect, useState } from 'react';

export type Theme = 'light' | 'dark';
const KEY = 'boqbox_theme';
const EVENT = 'boqbox:theme';

const current = (): Theme => (document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light');

export const applyTheme = (theme: Theme, persist = true) => {
  document.documentElement.setAttribute('data-theme', theme);
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'dark' ? '#0E0F12' : '#F6F6F4');
  if (persist) {
    try {
      localStorage.setItem(KEY, theme);
    } catch {
      // storage unavailable: the theme still applies for this visit
    }
  }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: theme }));
};

/** Current theme plus a toggle. Light by default; all components using it stay in sync. */
export function useTheme() {
  const [theme, setTheme] = useState<Theme>(current);

  useEffect(() => {
    const sync = () => setTheme(current());
    window.addEventListener(EVENT, sync);
    return () => window.removeEventListener(EVENT, sync);
  }, []);

  const toggle = useCallback(() => applyTheme(current() === 'dark' ? 'light' : 'dark'), []);
  return { theme, toggle };
}
